import { SearchAdResult } from "@models/searchAdResult.ts";
import { SearchTemplatesSerializer } from "../../../models/serializers/SearchTemplatesSerializer.ts";
import { httpRequest } from "../../http";

export class CommandSearchContent{
    async run(filter: object) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/search/`
        try {
            const response = await httpRequest<any>(url, { method: "POST", body: filter });
            if(response) {
                return this.deserialize(response);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }


    deserialize(data: any) : SearchAdResult [] {
        const serializer = new SearchTemplatesSerializer();
        return serializer.deserializeList(data);
    }

}
